export default {
  setProfileState: false,
};
